(() => {
  const init = (root) => {
    if (!root || root.dataset.ssCollectionReady === 'true') return;
    root.dataset.ssCollectionReady = 'true';

    const form = root.querySelector('[data-ss-collection-form]');
    const sort = root.querySelector('[data-ss-collection-sort]');
    const grid = root.querySelector('[data-ss-collection-grid]');
    const viewButtons = [...root.querySelectorAll('[data-ss-collection-view]')];
    const mobileFilter = root.querySelector('.ss-collection__mobile-filter');
    const activeCount = root.querySelector('[data-ss-active-count]');

    sort?.addEventListener('change', () => form?.requestSubmit());

    root.querySelectorAll('.ss-collection__filter').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        root.querySelectorAll('.ss-collection__filter[open]').forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const editorial = button.dataset.ssCollectionView === 'editorial';
        grid?.classList.toggle('is-editorial', editorial);
        viewButtons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
      });
    });

    if (activeCount && form) {
      const activeValues = new Set();
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => activeValues.add(`${input.name}:${input.value}`));
      form.querySelectorAll('input[type="number"]').forEach((input) => {
        if (input.value) activeValues.add(input.name);
      });
      activeCount.textContent = activeValues.size ? String(activeValues.size) : '';
    }

    root.querySelector('[data-ss-filter-close]')?.addEventListener('click', () => {
      mobileFilter?.removeAttribute('open');
      document.documentElement.classList.remove('ss-filter-open');
    });

    mobileFilter?.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('ss-filter-open', mobileFilter.open);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        root.querySelectorAll('details[open]').forEach((detail) => detail.removeAttribute('open'));
        document.documentElement.classList.remove('ss-filter-open');
      }
    });
  };

  document.querySelectorAll('[data-ss-collection]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ss-collection]').forEach(init);
  });
})();
